import React, { useEffect } from "react";
import './styles.css'
import PageHeader from "../../../components/header";
import ExamPaper from "../../../components/examPaper";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAxios } from "../../../hooks/useAxios";
import { ApiCollection } from "../../../config/envConfig";
import SpinnerLoader from "../../../components/loader";
import AnswerKey from "../../../components/answerKey";
import { useUser } from "../../../redux/useStore";
import { ExamPaperType } from "../../../utils/interface/exam";
// import Modal from "../../../components/modal";

export default function AssessmentViewScreen() {

    useEffect(() => {

        getExamData()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const axios = useAxios()
    const navigate = useNavigate()
    const localUser = useUser()


    // const [showModal, setShowModal] = React.useState(JSON.parse(localStorage.getItem('instructionsSeen') || 'false'))
    const [isLoading, setIsLoading] = React.useState(true);
    const [examData, setExamData] = React.useState<ExamPaperType | null>(null);
    const [answerData, setAnswerData] = React.useState(null);

    const [examScrollPosition, setExamScrollPosition] = React.useState(0);
    const [answerScrollPosition, setAnswerScrollPosition] = React.useState(0);

    const examViewRef = React.useRef<HTMLDivElement>(null);
    const answerViewRef = React.useRef<HTMLDivElement>(null);


    const [viewType, setViewType] = React.useState<'exam' | 'answer'>('exam')

    const [searchParams] = useSearchParams()

    const assessmentId = searchParams.get('assessmentId');

    const getExamData = async () => {
        setIsLoading(true)
        await axios.get(`${ApiCollection.exam.getExamQuestions}/${assessmentId}`)
            .then((res) => {

                setExamData(res.data)
                getAnswerKey()
                setIsLoading(false)
            })
            .catch((err) => {
                setIsLoading(false)
                console.log("Exam Error -");
                console.log(err)
                navigate(-1)
            })
    }

    const getAnswerKey = async () => {

        await axios.get(`${ApiCollection.exam.getAnswerKey}/${assessmentId}`)
            .then((res) => {
                setAnswerData(res.data)
            })
            .catch((err) => {
                console.log("Answer Error -");
                console.log(err)
            })
    }

    const approveExam = async () => {

        if (localUser?.role !== 'admin') {
            alert('You are not authorized to approve exams')
            return
        }
        setIsLoading(true)
        await axios.put(ApiCollection.exam.approveExam, { assessment: assessmentId })
            .then((res) => {
                alert('Exam Approved')
                navigate(-1)
            })
            .catch((err) => {
                alert('Error approving exam')
                console.log("Approve Exam Error -");
                console.log(err)
            })
            .finally(() => {
                setIsLoading(false)
            })


    }

    const switchType = () => {
        // Save current scroll position before switching
        if (viewType === 'exam' && examViewRef.current) {
            setExamScrollPosition(examViewRef.current.scrollTop);
        } else if (viewType === 'answer' && answerViewRef.current) {
            setAnswerScrollPosition(answerViewRef.current.scrollTop);
        }
        setViewType(viewType === 'exam' ? 'answer' : 'exam');
    };

    // Restore scroll position after view type changes
    React.useEffect(() => {
        if (viewType === 'exam' && examViewRef.current) {
            examViewRef.current.scrollTo({
                top: examScrollPosition,
                behavior: 'smooth'
            });
        } else if (viewType === 'answer' && answerViewRef.current) {
            answerViewRef.current.scrollTo({
                top: answerScrollPosition,
                behavior: 'smooth'
            });
        }
    }, [viewType, examScrollPosition, answerScrollPosition]);


    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh', width: '100%' }}>
                <SpinnerLoader />
                <h2 style={{ marginTop: 10, fontSize: 20 }}>
                    Loading...
                </h2>
            </div>
        )

    }

    return (
        <div className="assessment_view">
            <div
                ref={viewType === 'exam' ? examViewRef : answerViewRef}
                className="wrapper"
                style={{ width: '95%', padding: 25, overflowY: 'auto' }}>
                <PageHeader
                    title="Assessment / View"
                    right={
                        localUser?.role === 'admin' && examData &&
                        examData.is_approved === false &&
                        <div className='page-action-button' onClick={approveExam}>
                            <span>Approve Exam</span>
                        </div>
                    }
                />
                <div className='page-action-button exam-tool' onClick={switchType}>
                    <span>View Answers</span>
                </div>
                {
                    viewType === 'exam' ?
                        examData && <ExamPaper data={examData} />
                        :
                        answerData && <AnswerKey data={answerData} />
                }
            </div>
        </div>
    )


}